import { createConfigExperiment, getExperiment } from '@pegasus/abtesting';
import { useSelector } from 'react-redux';

export const deliveryFlagProjectId = '93655071-a339-4b27-8622-ee2ad9e8a399';
export const deliveryFlagControl = 'fast_delivery_flag_control';
export const deliveryFlagVariant = 'fast_delivery_flag_variant';

export const useDeliveryFlagVariant = () => {
    // @ts-ignore
    const experiment = useSelector(state => getExperiment(state, deliveryFlagProjectId));

    if (!experiment) {
        return false;
    }

    // @ts-ignore
    return experiment?.variant === deliveryFlagVariant;
};

export default createConfigExperiment({
    projectId: deliveryFlagProjectId,
    variants: [deliveryFlagControl, deliveryFlagVariant],
});
